import api from '../api';

/**
 * Gets notifications valid for today.
 *
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const getNotifications = async () => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/notification/getAll`;
  try {
    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    console.error('Error getting notifications:', error);
    throw error;
  }
}

export default getNotifications;
